import React, { Component } from 'react';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';
import { stripHTMLFromString } from './ProductHelpers';
import Asset from './Asset';

export default class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openToggle: props.expanded,
    };
  }

  renderSections() {
    const {
      points,
    } = this.props;
    return points.map((section, i) => (
      <div className={`about-this-piece-wrapper-section section-${i}`} key={i}>
        {section.images && section.images.length > 0 && Details.renderPointImage(section)}
        <p className="header">{section.header}</p>
        <p className="description">{section.subHeader}</p>
      </div>
    ));
  }

  static renderPointImage(section) {
    return section.images && section.images.length && (
      <LazyLoad height="100%" offset={0}>
        <Asset
          asset={section.images[0]}
          outerWrapperClassName="about-this-piece-wrapper-section-image"
        />
      </LazyLoad>
    );
  }

  render() {
    return (
      <section
        id={this.props.anchor || undefined}
        className="pdp-btf-section about-this-piece"
      >
        <div
          className={`pdp-btf-section-title ${this.state.openToggle ? 'active' : ''}`}
          onClick={this.props.toggleAccordion?.bind(this)}
        >
          <h2>{this.props.subHeader}</h2>
          <div className="icon-container">
            <i className={classNames('icon', 'icon-nav-arrow', { active: this.state.openToggle })}/>
          </div>
        </div>
        <div className={`pdp-btf-section-wrapper ${this.state.openToggle ? 'active' : ''}`}>
          <h3 className="about-this-piece-wrapper-description">{stripHTMLFromString(this.props.productDetails?.description)}</h3>
          <div className="about-this-piece-wrapper-sections">
            {this.renderSections()}
          </div>
        </div>
      </section>
    );
  }
}
